var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { defaultProps } from './defaults';
import { DivTag } from '../../Utils/AtomicTag';
import { TabsPanel } from './TabPanel';
export var atomicMapTab = {
    activeBorder: ['text-brand-600', 'border-brand-600'],
    activeCard: [
        'text-brand-600',
        'border-brand-600',
        'border',
        'border-solid',
        'border-gray-200',
        'border-b-0',
        'bg-white',
        'pb-px-1',
    ],
    activeBtn: ['text-brand-600', 'border', 'border-solid', 'border-brand-600'],
    commonBorderSm: ['text-xs', 'pl-px-8', 'pr-px-8', 'h-px-36'],
    commonBorderMd: ['text-base', 'pl-px-12', 'pr-px-12', 'h-px-48'],
    commonBorderLg: ['text-lg', 'pl-px-16', 'pr-px-16', 'h-px-56'],
    commonCardSm: ['text-xs', 'pl-px-8', 'pr-px-8', 'h-px-36'],
    commonCardMd: ['text-base', 'pl-px-12', 'pr-px-12', 'h-px-48'],
    commonCardLg: ['text-lg', 'pl-px-16', 'pr-px-16', 'h-px-56'],
    commonBtnSm: ['text-xs', 'pl-px-8', 'pr-px-8', 'h-px-30'],
    commonBtnMd: ['text-base', 'pl-px-12', 'pr-px-12', 'h-px-32'],
    commonBtnLg: ['text-lg', 'pl-px-16', 'pr-px-16', 'h-px-40'],
    btnFristClass: ['border', 'border-solid', 'rounded-l-default'],
    btnLastClass: ['border', 'border-solid', 'rounded-r-default', 'border-l-0'],
    btnClass: ['border', 'border-solid', 'border-l-0'],
    atomics: [
        'flex',
        'flex-initial',
        'flex-row',
        'items-center',
        'hover:text-brand-600',
        'cursor-pointer',
    ],
    normalUnderline: ['border-gray-200'],
    tabsBody: ['text-base', 'border', 'border-solid', 'border-gray-200', 'border-t-0'],
    tabsHeadBorder: ['border-b', 'border-solid', 'border-gray-200'],
    tabBox: ['overflow-hidden', 'relative', '-mb-px-1'],
    tabBoxBorder: ['h-px-2', 'bg-brand-600'],
    tabBoxInnerFlex: ['flex', 'flex-initial', 'flex-row'],
};
export var setTabClsObj = {
    small: {
        border: { active: atomicMapTab.activeBorder, common: atomicMapTab.commonBorderSm },
        card: { active: atomicMapTab.activeCard, common: atomicMapTab.commonCardSm },
        button: { active: atomicMapTab.activeBtn, common: atomicMapTab.commonBtnSm },
    },
    normal: {
        border: { active: atomicMapTab.activeBorder, common: atomicMapTab.commonBorderMd },
        card: { active: atomicMapTab.activeCard, common: atomicMapTab.commonCardMd },
        button: { active: atomicMapTab.activeBtn, common: atomicMapTab.commonBtnMd },
    },
    large: {
        border: { active: atomicMapTab.activeBorder, common: atomicMapTab.commonBorderLg },
        card: { active: atomicMapTab.activeCard, common: atomicMapTab.commonCardLg },
        button: { active: atomicMapTab.activeBtn, common: atomicMapTab.commonBtnLg },
    },
};
function outerWidth(el) {
    var width = el.offsetWidth;
    var style = el.currentStyle || getComputedStyle(el);
    width += parseInt(style.marginLeft) + parseInt(style.marginRight);
    return width;
}
var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        _this.contenItem = React.createRef();
        _this.container = React.createRef();
        _this.headerItems = [];
        // 点击切换tab
        _this.goTo = function (key) {
            var _a = _this.props, onChange = _a.onChange, onBeforeChange = _a.onBeforeChange;
            if (_this.state.activeKey !== key) {
                if (onBeforeChange(key, _this)) {
                    _this.setState({
                        activeKey: key,
                    }, function () {
                        onChange(key, _this);
                    });
                }
            }
        };
        _this.renderTabs = function () {
            var _a = _this.props, type = _a.type, style = _a.style, children = _a.children;
            var _b = _this.state, activeKey = _b.activeKey, navBarWidth = _b.navBarWidth;
            var keys = React.Children.map(children, function (child) { return child && child.key; });
            var tabsBody = [];
            var tabsHeadBorder = [];
            if (type === 'card') {
                tabsBody = atomicMapTab.tabsBody;
            }
            if (type !== 'button') {
                tabsHeadBorder = atomicMapTab.tabsHeadBorder;
            }
            var activeIndex = keys === null || keys === void 0 ? void 0 : keys.indexOf(activeKey);
            return (React.createElement("div", { ref: _this.container, style: style },
                React.createElement(DivTag, { atomics: tabsHeadBorder, autoPrefixedClassName: "tabs-header-box" },
                    React.createElement(DivTag, { atomics: atomicMapTab.tabBox, autoPrefixedClassName: "tabs-header" },
                        React.createElement(DivTag, { atomics: atomicMapTab.tabBoxInnerFlex, autoPrefixedClassName: "tabs-titles" }, _this.renderHead()),
                        type === 'border' && (React.createElement(DivTag, { atomics: atomicMapTab.tabBoxBorder, style: {
                                width: navBarWidth[activeIndex],
                                transform: "translateX(" + _this.calcLeft(activeIndex ? activeIndex : 0) + "px)",
                                transition: "width .4s,transform .2s ease-out",
                            }, autoPrefixedClassName: "tabs-header-line" })))),
                React.createElement(DivTag, { atomics: tabsBody }, _this.renderBody())));
        };
        var activeKey;
        if (props.activeKey) {
            activeKey = props.activeKey;
        }
        else if (props.defaultActiveKey) {
            activeKey = props.defaultActiveKey;
        }
        else {
            activeKey = getDefaultActiveKey(props);
        }
        _this.state = {
            activeKey: activeKey,
            navBarWidth: [],
            offsetWidths: [],
            childrenLength: React.Children.count(_this.props.children),
        };
        return _this;
    }
    Tabs.prototype.componentDidMount = function () {
        this.setActiveBarWidth();
    };
    Tabs.getDerivedStateFromProps = function (props, state) {
        var newState = {};
        if (props.activeKey) {
            newState.activeKey = props.activeKey;
        }
        else if (!activeKeyIsValid(props, state.activeKey)) {
            newState.activeKey = getDefaultActiveKey(props);
        }
        if (Object.keys(newState).length > 0) {
            return newState;
        }
        return null;
    };
    // 设置切换按钮宽度
    // 设置切换按钮宽度
    Tabs.prototype.setActiveBarWidth = function () {
        var type = this.props.type;
        if (this.container) {
            var itemNodes = this.headerItems;
            var widths = itemNodes.map(function (i) {
                return i && i.getBoundingClientRect ? i.getBoundingClientRect().width : 0;
            });
            var offsetWidths = itemNodes.map(function (i) { return (i ? outerWidth(i) : 0); });
            this.setState({
                navBarWidth: widths,
                offsetWidths: offsetWidths,
            });
        }
    };
    Tabs.prototype.renderHead = function () {
        var _this = this;
        var activeKey = this.state.activeKey;
        var _a = this.props, children = _a.children, triggerEvent = _a.triggerEvent, type = _a.type, size = _a.size;
        if (!children) {
            return null;
        }
        var sizeCls = setTabClsObj[size][type];
        var active = sizeCls === null || sizeCls === void 0 ? void 0 : sizeCls.active;
        var common = sizeCls === null || sizeCls === void 0 ? void 0 : sizeCls.common;
        return React.Children.map(children, function (child, index) {
            //胶囊式标签
            var buttonClass = [];
            if (type === 'button') {
                if (index == 0) {
                    buttonClass = atomicMapTab.btnFristClass;
                }
                else if (index == React.Children.count(_this.props.children) - 1) {
                    buttonClass = atomicMapTab.btnLastClass;
                }
                else {
                    buttonClass = atomicMapTab.btnClass;
                }
            }
            common && (buttonClass = buttonClass.concat(common));
            var activeCls = (activeKey === child.key
                ? active
                : atomicMapTab.normalUnderline);
            return (React.createElement(DivTag, { key: index, ref: function (node) {
                    _this.headerItems.push(node);
                }, atomics: atomicMapTab.atomics.concat(buttonClass, activeCls), onClick: function () {
                    triggerEvent === 'click' && _this.goTo(child.key);
                }, onMouseOver: function () {
                    triggerEvent === 'mouseover' && _this.goTo(child.key);
                }, style: type === 'button' && activeKey === child.key && index !== 0
                    ? {
                        boxShadow: '-1px 0 0 0 #0083FF',
                    }
                    : undefined, autoPrefixedClassName: activeKey === child.key ? 'tabs-title tabs-title-active' : 'tabs-title' }, child.props.label));
        });
    };
    Tabs.prototype.renderBody = function () {
        var children = this.props.children;
        var activeKey = this.state.activeKey;
        if (!children) {
            return null;
        }
        return React.Children.map(children, function (child, index) {
            var childProps = __assign(__assign({}, child.props), { active: activeKey === child.key });
            var newChild = React.cloneElement(child, childProps);
            return newChild;
        });
    };
    Tabs.prototype.calcLeft = function (index) {
        var _a = this.state, navBarWidth = _a.navBarWidth, offsetWidths = _a.offsetWidths;
        var len = navBarWidth.length;
        var outerWidth = offsetWidths[index];
        var width = navBarWidth[index];
        if (navBarWidth.length == 0 || index == 0)
            return (outerWidth - width) / 2;
        var result = offsetWidths.slice(0, index).reduce(function (pre, cur, i) {
            return pre + cur;
        });
        return result + Math.floor((outerWidth - width) / 2);
    };
    Tabs.prototype.render = function () {
        var _a = this.props, className = _a.className, style = _a.style, onBeforeChange = _a.onBeforeChange, onChange = _a.onChange, activeKey = _a.activeKey, defaultActiveKey = _a.defaultActiveKey, triggerEvent = _a.triggerEvent, rest = __rest(_a, ["className", "style", "onBeforeChange", "onChange", "activeKey", "defaultActiveKey", "triggerEvent"]);
        return (React.createElement(DivTag, __assign({ name: Tabs.NAME, className: className, style: style }, rest), this.renderTabs()));
    };
    Tabs.Panel = TabsPanel;
    Tabs.defaultProps = defaultProps;
    Tabs.NAME = 'tabs';
    Tabs.displayName = 'Tabs';
    return Tabs;
}(React.PureComponent));
export { Tabs };
function activeKeyIsValid(props, key) {
    if (!props.children)
        return 0;
    var keys = React.Children.map(props.children, function (child) { return child && child.key; });
    return keys.indexOf(key) >= 0;
}
function getDefaultActiveKey(props) {
    var activeKey = '';
    if (!props.children)
        return activeKey;
    React.Children.forEach(props.children, function (child) {
        if (child && !activeKey && !child.disabled) {
            activeKey = child.key;
        }
    });
    return activeKey;
}
